import { useLang } from "../../context/LangContext";
import { ADMIN_TRANSLATIONS } from "../utils/adminTranslations";

export function useAdminLang() {
  const { lang, setLang } = useLang();
  const t = ADMIN_TRANSLATIONS[lang] ?? ADMIN_TRANSLATIONS.en;
  return { t, lang, setLang };
}
